import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './dropdown';

class SearchDropdown extends Component {
    constructor(props) {
        super(props);

        this._onDropdownChangeHandler = this._onDropdownChangeHandler.bind(this);
        this._onSearchHandler = this._onSearchHandler.bind(this);

        this.lastSelectedValue = "";
    }

    render() {
        let {
            id,
            label,
            buttonLabel,
            onSearch,
            value,
            ...dropdownProps
        } = this.props;

        this.lastSelectedValue = value;

        return (
            <div className="form-group">
                <label htmlFor={id} className="col-sm-3 control-label">
                    <span className="field-name">{label}</span>
                </label>
                <div className="col-sm-9">
                    <div className="input-group">
                        <Dropdown id={id} onChange={this._onDropdownChangeHandler}  {...dropdownProps} />
                        <span className="input-group-btn">
                            <input type="button" className="btn btn-primary" value={buttonLabel} onClick={this._onSearchHandler} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    _onDropdownChangeHandler(elem,value,label) {
        this.lastSelectedValue = value;
    }

    _onSearchHandler() {
        this.props.onSearch(this.lastSelectedValue);
    }
}

SearchDropdown.propTypes = {
    "id": PropTypes.string.isRequired,
    "label": PropTypes.string,
    "buttonLabel": PropTypes.string,
    "onSearch": PropTypes.func.isRequired
};

export default SearchDropdown;